export default __webpack_public_path__ + "static/media/multiformatads.7ee3cb73.svg";